import { createApp } from 'vue'
import './styles/theme.css'
import './styles/styles.css'
import './styles/pilotage.css'
import './styles/loader.css'
import './styles/cultures.css'
import './styles/history.css'
import './styles/reactorState.css'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { useThemeStore } from './stores/themeStore'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { createI18n } from 'vue-i18n'

import enCommon from './locales/en/common.json'
import frCommon from './locales/fr/common.json'
import enAuth from './locales/en/auth.json'
import frAuth from './locales/fr/auth.json'
import frPilotage from './locales/fr/pilotage.json'
import enPilotage from './locales/en/pilotage.json'
import enFooter from './locales/en/footer.json'
import frFooter from './locales/fr/footer.json'
import enCultures from './locales/en/cultures.json'
import frCultures from './locales/fr/cultures.json'
import enAnalyses from './locales/en/analyses.json'
import frAnalyses from './locales/fr/analyses.json'
import enHarvests from './locales/en/harvests.json'
import frHarvests from './locales/fr/harvests.json'
import enSamples from './locales/en/samples.json'
import frSamples from './locales/fr/samples.json'
import frYiedls from './locales/fr/productivity.json'
import enYiedls from './locales/en/productivity.json'
import frLiveData from './locales/fr/livedata.json'
import enLiveData from './locales/en/livedata.json'
import frStrains from './locales/fr/strains.json'
import enStrains from './locales/en/strains.json'
import frPredictions from './locales/fr/predictions.json'
import enPredictions from './locales/en/predictions.json'

const app = createApp(App)
const pinia = createPinia()

const savedLocale = localStorage.getItem('locale') || 'fr'

const messages = {
  en: {
    ...enCommon,
    ...enAuth,
    ...enPilotage,
    ...enFooter,
    ...enCultures,
    ...enAnalyses,
    ...enHarvests,
    ...enSamples,
    ...enYiedls,
    ...enLiveData,
    ...enStrains,
    ...enPredictions
  },
  fr: {
    ...frCommon,
    ...frAuth,
    ...frPilotage,
    ...frFooter,
    ...frCultures,
    ...frAnalyses,
    ...frHarvests,
    ...frSamples,
    ...frYiedls,
    ...frLiveData,
    ...frStrains,
    ...frPredictions
  }
}

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages
})


app.use(i18n)
app.use(pinia)
app.use(router)
app.use(Toast, {
  position: "bottom-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
})

const { currentTheme } = useThemeStore()
document.documentElement.setAttribute('data-theme', currentTheme.value)

app.mount('#app')
